<!-- Navigation Links -->
<div class="p-3">
  <nav class="nav flex-column">
    
    <!-- Personal Information Link -->
    <a class="nav-link d-flex align-items-center py-3 px-2 rounded text-decoration-none"
       [class.active]="activePanel === 'personal'"
       [class.bg-light]="activePanel === 'personal'"
       [class.text-primary]="activePanel === 'personal'"
       [class.text-dark]="activePanel !== 'personal'"
       href="#" 
       (click)="setActivePanel('personal'); $event.preventDefault()">
      <i class="fa fa-user me-3"></i>
      <span class="grow">Personal Information</span>
      <i class="fa fa-chevron-right ms-2 small"></i>
    </a>

    <!-- Course Information Link -->
    <a class="nav-link d-flex align-items-center py-3 px-2 rounded text-decoration-none mt-1"
       [class.active]="activePanel === 'courses'"
       [class.bg-light]="activePanel === 'courses'"
       [class.text-primary]="activePanel === 'courses'"
       [class.text-dark]="activePanel !== 'courses'"
       href="#" 
       (click)="setActivePanel('courses'); $event.preventDefault()">
      <i class="fa fa-book me-3"></i>
      <span class="grow">Course Information</span>
      <i class="fa fa-chevron-right ms-2 small"></i>
    </a>

    <!-- Account Activity Link -->
    <a class="nav-link d-flex align-items-center py-3 px-2 rounded text-decoration-none mt-1"
       [class.active]="activePanel === 'activity'"
       [class.bg-light]="activePanel === 'activity'"
       [class.text-primary]="activePanel === 'activity'"
       [class.text-dark]="activePanel !== 'activity'"
       href="#" 
       (click)="setActivePanel('activity'); $event.preventDefault()">
      <i class="fa fa-chart-line me-3"></i>
      <span class="grow">Account Activity</span>
      <i class="fa fa-chevron-right ms-2 small"></i>
    </a>
  </nav>
</div>